module.exports = __webpack_public_path__ + "static/media/facility-smoking-policy.4ed8ea40.svg";